import React from "react";
import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useChat } from "../features/chat/hooks/useChat";
import CallModal from "../features/call/ui/CallModal";


export default function ProtectedRoutes() {
    const location = useLocation();
    const { currentUser, activeCall, initializing } = useChat();

    // 1. Loading State
    if (initializing) return <div className="flex h-screen items-center justify-center">Loading...</div>;

    // 2. Auth Check
    if (!currentUser) return <Navigate to="/login" replace />;

    // 3. Dispatch desk: these accounts have exactly two pages. Send them there from
    //    anywhere else, so a stale tab or a bookmarked dashboard does not strand them
    //    on a screen they have no access to.
    const deskRole = String(currentUser.role || '').toLowerCase();
    if ((deskRole === 'dispatch' || deskRole === 'handover') && !location.pathname.startsWith('/handover') && !location.pathname.startsWith('/qc')) {
        return <Navigate to="/handover" replace />;
    }
    // Parcel QC inspectors have exactly one page.
    if (deskRole === 'qc' && !location.pathname.startsWith('/qc')) {
        return <Navigate to="/qc" replace />;
    }

    // 3. Render
    return (
        <>
            {/* The call screen reads everything it needs from the chat context. */}
            {activeCall && <CallModal />}
            <Outlet />
        </>
    );
}
